import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListService = createAsyncThunk(
  "services/getListService",
  async ({ currentPage, pageSize }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/serviceconnect/services?has_paginate&size=${pageSize}&page=${currentPage}`;
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

export const createService = createAsyncThunk(
  "services/createService",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/services`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateService = createAsyncThunk(
  "services/updateService", // Đổi tên hành động cho phù hợp
  async ({ id, data }, { rejectWithValue }) => { // Lấy đối tượng có `id` và `data`
    try {
      const response = await http.put(`/api/v1/serviceconnect/services/${id}`, data); // Gọi API PUT
      return response.data; // Trả về kết quả thành công
    } catch (error) {
      return rejectWithValue(error.response.data); // Trả về lỗi nếu có
    }
  }
);

export const deleteService = createAsyncThunk(
  "services/deleteService",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/services/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);